import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthUserContextType, useAuthUserContext } from '../../providers/AuthUser';
import { useTitle } from '../../hooks/useTitle';

const Welcome = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authUser: AuthUserContextType = useAuthUserContext();

  useTitle('Ton Bébé | ようこそ');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search.slice(1));
    const params = Object.fromEntries(searchParams.entries());

    authUser.external_signin(
      params,
      () => {
        toast.success('ログインしました。');
        navigate('/mypage');
      },
      () => {
        toast.error('ログインに失敗しました。時間をおいて再度お試しください。');
        navigate('/');
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ location.search ]);

  return (
    <div>
      <main className="sub">
        <section className="welcome">
          <div className="welcome-message">
            <h1>ようこそ Ton Bébé へ</h1>
            <h2>ログイン処理中です...</h2>
            <p>しばらくお待ちください。</p>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Welcome;
